import { Tab, Tabs } from "react-bootstrap";
import { useEffect, useState } from "react";
import "./inventoryprofile.scss";
import InventoryProfileHeader from "../../../components/inventoryprofileheader/InventoryProfileHeader";
import { useAppSelector } from "../../../redux/hooks";
import {
  Barcode,
  selectedInventoryItem,
} from "../../../redux/inventory/inventorySlice";
import { BasicInfoTab } from "./basicInfoTab/basicInfoTab";
import { InventoryManagementTab } from "./inventoryManagementTab/inventoryManagementTab";
import { useLocation, useNavigate } from "react-router-dom";

import { OrderManagementTab } from "./OrderManagementTab/OrderManagementTab";
import Loading from "../../../components/LoadingPage/Loading";
import { DuplicateItemModel } from "../Itemlisting/popUpModels/duplicateItemModel";
import {
  getBarcodeVales,
  toggleClass,
} from "../../../utils/commonUtils";
import { OrderManagementDetails } from "./OrderManagementTab/popUp/OrderManagementDetails";
import { BarcodeManagementTab } from "./barcodeManagementTab/barcodeManagementTab";
import { HistoryTab } from "./historyTab/historyTab";
import useInventory from "../../../Hooks/useInventory";
import { PrintBarcodePopUp } from "./printBarcodePopUp/printBarcodePopUp";
import React, { useMemo } from "react";
import { selectSystemSettings, SettingName } from "../../../redux/settings/settingsSlice";

interface labelOption {
  value: string;
  label: string;
}

const InventoryProfile = () => {
  const selectedItem = useAppSelector(selectedInventoryItem);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(
    location.state?.activeTab || "overview"
  );
  const [invManageData, setInvManageData] = useState<any>([]);
  const onShowReportModal = () => navigate("/inventory-transaction-report");
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [selectedOrdManItem, setSelectedOrdManItem] = useState<any>();
  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [defaultBarcodes, setDefaultBarcodes] = useState<Barcode>();
  const [selectedLabel, setSelectedLabel] = useState<labelOption>({
    value: "",
    label: "",
  });
  const { getBarcodesAPI, getBarcodesLoading, barcodePrintAPI } =
    useInventory();
  const systemSettings = useAppSelector(selectSystemSettings);
  const settingsList = useMemo(() => {
    return systemSettings[SettingName.ITEM_PAGE_SETTINGS] ?? {};
  }, [systemSettings]);
  const [orderMgmtTabErr, setOrderMgmtTabErr] = useState<string>();
  const [showOrderMngtDetailModal, setShowOrderMngtDetailModal] =
    useState(false);
  const [isUseFor, setIsUseFor] = useState<string>("View");
  const getBarcodeList = () => {
    getBarcodesAPI(selectedItem.id).then((res: any) => {
      if (res) {
        setDefaultBarcodes(res.find((x: any) => x.isDefault));
      }
    });
  };

  useEffect(() => {
    getBarcodeList();
  }, []);
  useEffect(() => {
    if (!selectedItem) {
      navigate("/inventory");
    }
    setLoading(false);
  }, [loading]);

  const toggleOrderMngtDetailModal = () => {
    toggleClass();
    setShowOrderMngtDetailModal(!showOrderMngtDetailModal);
  };

  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };
  const toggleBarcodeModal = () => {
    toggleClass();
    setShowBarcodeModal(!showBarcodeModal);
  };

  const reloadListing = () => {
    navigate("/inventory");
  };
  const selectOrdManItem = (item: any) => {
    setSelectedOrdManItem(item);
  };
  const printBarcode = (
    lableId: string,
    selectedItem: any,
    selectedBarcode?: string
  ) => {
    const updatedItem =
      selectedBarcode && selectedItem?.rxSRXId
        ? { ...selectedItem, rxSRXId: selectedBarcode }
        : selectedItem;
    const barcodeVales = getBarcodeVales(updatedItem);
    barcodePrintAPI({
      lableId: lableId,
      barcodeVales: barcodeVales,
    }).then((res: any) => {
      window.open(res, "_blank", "noopener,noreferrer");
    });
  };
  const showRequiredOderProdError = (tab: string | null) => {
    if (!!!selectedItem?.orderingProductMasterId && tab === "ordmngt") {
      setOrderMgmtTabErr("No ordering product found for this item.");
      return;
    }
    setOrderMgmtTabErr("");
  };
  const refreshOMTab = (data: any) => {
    setInvManageData(data);
  };
  return (
    <>
      {loading || getBarcodesLoading ? (
        <Loading />
      ) : (
        <div className="inventory-profile-wrapper">
          <InventoryProfileHeader
            status={selectedItem.isActive}
            itemName={selectedItem.rxName}
            itemBarcode={selectedItem.rxSRXId}
            isAddButtonShow={Boolean(isUseFor?.toLowerCase() === "view")}
          />
          <div className="profile-detail-box-wrapper">
            <div className="inventory-profile-detail-box">
              <Tabs
                activeKey={activeTab}
                id="inventory-profile-tab"
                className="mb-3"
                onSelect={(tab) => {
                  showRequiredOderProdError(tab);
                  if (tab) setActiveTab(tab);
                }}
              >
                <Tab eventKey="overview" title="Overview">
                  <BasicInfoTab
                    toggleBarcodeModal={toggleBarcodeModal}
                    toggleDuplicateModal={toggleDuplicateModal}
                    selectedItem={selectedItem}
                    selectedLabel={selectedLabel}
                    setSelectedLabel={setSelectedLabel}
                    settingsList={settingsList}
                    useFor={isUseFor}
                    setUseFor={setIsUseFor}
                    onShowReportModal={onShowReportModal}
                  />
                </Tab>
                <Tab eventKey="invtmngt" title="Inventory Management">
                  <InventoryManagementTab
                    onShowReportModal={onShowReportModal}
                    selectedItem={selectedItem}
                    refreshOMTab={refreshOMTab}
                  />
                </Tab>

                {settingsList?.hasOwnProperty('OrderingModuleEnabled') && settingsList?.OrderingModuleEnabled && (
                  <Tab eventKey="ordmngt" title="Order Management">
                    <OrderManagementTab
                      toggleOrderMngtDetailModal={toggleOrderMngtDetailModal}
                      selectedItem={selectedItem}
                      setSelectedOrdManItem={selectOrdManItem}
                      invManageData={invManageData}
                      orderMgmtTabErr={orderMgmtTabErr}
                    />
                  </Tab>
                )}

                <Tab eventKey="barcodes" title="Barcode Management">
                  <BarcodeManagementTab
                    selectedItem={selectedItem}
                    printBarcode={printBarcode}
                    selectedLabel={selectedLabel}
                  />
                </Tab>

                <Tab eventKey="history" title="History">
                  <HistoryTab selectedItem={selectedItem} />
                </Tab>
              </Tabs>
            </div>
          </div>

          {/* Duplicate Item Modal */}
          <DuplicateItemModel
            selectedItem={selectedItem}
            toggleDuplicateModal={toggleDuplicateModal}
            showModal={showDuplicateModal}
            reloadListing={reloadListing}
          />

          {/* Barcode Modal */}
          <PrintBarcodePopUp
            showBarcodeModal={showBarcodeModal}
            toggleBarcodeModal={toggleBarcodeModal}
            printBarcode={printBarcode}
            defaultBarcodes={defaultBarcodes}
          />

          {/* Order Mngt Detail Modal */}
          <OrderManagementDetails
            showOrderMngtDetailModal={showOrderMngtDetailModal}
            toggleOrderMngtDetailModal={toggleOrderMngtDetailModal}
            selectedOrdManItem={selectedOrdManItem}
            selectedItem={selectedItem}
          />

        </div>
      )}
    </>
  );
};

export default InventoryProfile;
